import "./index.less";
import ProjectHeader from "./header/header";
import { useEffect, useContext } from 'react';
import MenuBar from "./menu";
import OperationBar from "./operation-bar";
import { EngineContext, NavigationContext, RegisterContext } from "@/App";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import MainSidebar from "../sidebar";
import { IconButton, Tab } from "bimui";
import Draw from "./draw/draw";
import { findLayersInProjectUuid } from "@/declare/api/geometry/layer";
import { Layer } from "@/declare/interface/project/layer";
import FilePage from "./file-pages/file";
import localStore from "@/store/local-store";
import DrawAxisNet from "./axis-net";
import { RegisterStatus } from "@/store/register-store";
import { coreAxios } from "@/declare/api/axios";
import MaterialMarkPage from "./material-mark-page";
import { emitter } from "@/utils/mitt";
import { Emit_Event_Common_Tool } from "@/declare/enums/emit-event";
import SectionDetail from "./section-detail-page";
import CodePanel from "./code";
import { ReactComponent as ClearSvg } from "bimui/dist/c1/icons/clear.svg"
import ProjectUserPanel from "@/panel/user";
import { TabItemProps } from "@/store/navigation-context";
import BlockDetailPanel from "./block";
import BlockEditPanel from "@/panel/block/block-edit";
// /**
//  * 最大单次加载图元量
//  */
// const maxLoadPrimitiveNum = 1000;
/**
 * 主界面布局
 * @returns 
 */

export interface IProps {
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
    changeUserHelpVisible: (value: boolean) => void
}

export default function GraphicLayout(props: IProps) {
    const routeParams = useParams();
    const { feedbackVisible, changeFeedbackVisible, changeUserHelpVisible } = props;
    /**
     * 当前图形 UUID，从路由参数中获取。
     */
    const { projectUuid } = useParams();
    // 导航工具
    const navigate = useNavigate();
    // 导航存储
    const navigateContext = useContext(NavigationContext);
    // 引擎相关存储
    const engineContext = useContext(EngineContext);
    // 注册存储
    const registerContext = useContext<RegisterStatus>(RegisterContext);

    /**
     * 是否已经初始化，避免useEffect不停刷新
     */
    // const isInit = useRef<boolean>(false)

    /**
     * 载入图层
     */
    useEffect(() => {
        if (projectUuid == null) return;
        if (localStore.activeMajor == null) {
            localStore.activeMajor = "project";
        }
        // if (isInit.current) return
        findLayersInProjectUuid(projectUuid).then(res => {
            let layers: Layer[] = res.data || [];
            for (let layer of layers) {
                layer.lock = false;
                layer.hidden = false;
            }
            engineContext.setLayers(layers);
            if (layers.length > 0 && engineContext.currentLayerUuid == null) {
                engineContext.setCurrentLayerUuid(layers[0].uuid);
            }
        }).catch(err => {
            console.log(err);
        })

        return (() => {
            // 清空该项目的存储
            localStore.clearProjectInfo();
            navigateContext.setTabs([]);
            registerContext.activeSidebar(null);
            registerContext.activeTool(null);
        })
    }, [projectUuid])

    /**
     * 清空标签页
     */
    const onClearTabs = () => {
        navigateContext.clearTabs();
        navigate(`/projects/${projectUuid}`);
    }

    return (
        <div className="bim-project-container"
            tabIndex={0}
        // ref={containerRef}
        >
            <ProjectHeader feedbackVisible={feedbackVisible} changeFeedbackVisible={changeFeedbackVisible} changeUserHelpVisible={changeUserHelpVisible} />
            <MenuBar />
            <OperationBar />
            <div className="main">
                {/* <MainSidebar /> */}
                <Routes>
                    <Route path='models/:modelUuid' element={<MainSidebar />} />
                    <Route path='*' element={<MainSidebar />} />
                </Routes>
                <div className="view-panel">
                    <div className="tab-wrap">
                        <Tab tabs={navigateContext.tabs} activeKey={navigateContext.activeTabKey} onChange={(route) => {
                            if (route == null) {
                                // 说明没有页签了
                                registerContext.activeTool(null);
                                if (registerContext.sidebarPanels[registerContext.currentActivedSidebarKey] == null) {
                                    registerContext.activeSidebar(null);
                                }
                                navigate(`/projects/${projectUuid}`)
                                return;
                            }
                            navigateContext.setActiveTabKey(route);
                            navigate(route);
                        }} onClose={(key) => {
                            navigateContext.removeTab(key);
                        }} />
                        <div className="clear-icon"><IconButton icon={<ClearSvg />} onClick={onClearTabs}></IconButton></div>
                    </div>
                    <div className="view-container">
                        <Routes>
                            <Route path='/axis-net' element={<DrawAxisNet />} />
                            <Route path='files' element={<FilePage />} />
                            <Route path='/models/:modelUuid' element={<Draw />} />
                            <Route path='material-marks/:markId' element={<MaterialMarkPage />} />
                            <Route path='section-details/:sectionId' element={<SectionDetail />} />
                            <Route path='formulas/:formulaId' element={<CodePanel />} />
                            <Route path='/blocks' element={<BlockEditPanel />} />
                            <Route path='/blocks/*' element={<BlockEditPanel />} />
                            <Route path='users' element={<ProjectUserPanel />} />
                            {registerContext.routes.map(item =>
                                <Route path={item.path} element={<item.element {...engineContext}
                                    drawPanel={Draw}
                                    emitter={emitter}
                                    emitterType={Emit_Event_Common_Tool}
                                    registTab={(key: string, value: string) => {
                                        navigateContext.registTab({
                                            key: key,
                                            value: value,
                                        })
                                    }} activeTab={(key) => {
                                        navigateContext.setActiveTabKey(key)
                                    }} routeParams={routeParams}
                                    axios={coreAxios}
                                />} />
                            )}
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    );
}
